export const PRINT_STYLE = `
@media print {
  html, body {
    -webkit-print-color-adjust: exact;
  }
  .payment-summary__subtotal {
    width: 100% !important;
    position: inherit !important;
  }
  .payment-section__footer--collapsed {
    display: none !important;
  }
}
`;